import { useState, useCallback } from "react";

export function useCommentDraft(storageKey: string) {
  const [draft, setDraftState] = useState<string>(() => {
    try {
      return localStorage.getItem(storageKey) ?? "";
    } catch {
      return "";
    }
  });

  const setDraft = useCallback(
    (value: string | ((prev: string) => string)) => {
      setDraftState((prev) => {
        const next = typeof value === "function" ? value(prev) : value;
        try {
          if (next) {
            localStorage.setItem(storageKey, next);
          } else {
            localStorage.removeItem(storageKey);
          }
        } catch {
          // storage unavailable — ignore
        }
        return next;
      });
    },
    [storageKey]
  );

  const clearDraft = useCallback(() => {
    try {
      localStorage.removeItem(storageKey);
    } catch {
      // ignore
    }
    setDraftState("");
  }, [storageKey]);

  return [draft, setDraft, clearDraft] as const;
}
